import React from 'react';
import { Shield, Bitcoin, Percent, Lock } from 'lucide-react';
import { Translation } from '../types';

interface FeaturesProps {
  t: Translation['features'];
}

export const Features: React.FC<FeaturesProps> = ({ t }) => {
  const getIcon = (iconName: string) => {
    switch(iconName) {
      case 'shield': return <Shield className="w-8 h-8 text-blue-400" />;
      case 'bitcoin': return <Bitcoin className="w-8 h-8 text-orange-400" />;
      case 'percent': return <Percent className="w-8 h-8 text-green-400" />;
      case 'lock': return <Lock className="w-8 h-8 text-purple-400" />;
      default: return <Shield />;
    }
  };

  return (
    <section id="features" className="py-20 relative">
      <div className="container mx-auto px-4">
        
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">{t.title}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {t.items.map((item, index) => (
            <div 
              key={index}
              className="flex gap-6 p-8 rounded-2xl bg-slate-800/50 border border-slate-700/50 backdrop-blur-sm hover:bg-slate-800 transition-colors"
            >
              <div className="shrink-0 flex items-center justify-center w-16 h-16 rounded-2xl bg-slate-900 border border-slate-700">
                {getIcon(item.icon)}
              </div>
              <div>
                <h3 className="text-xl font-bold text-white mb-3">{item.title}</h3>
                <p className="text-slate-400 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

